import { render, staticRenderFns } from "./CoteacherList.vue?vue&type=template&id=76d0b9ec"
import script from "./CoteacherList.vue?vue&type=script&lang=js"
export * from "./CoteacherList.vue?vue&type=script&lang=js"
import style0 from "./CoteacherList.vue?vue&type=style&index=0&id=76d0b9ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports